angular.module('impactx.rfx').controller('RFXRequestSupportListCtrl', [
    'selectedListItems',
    'dataGen',
    'ToastService',
    '$redirect',
    RFXRequestSupportListCtrl
]);

function RFXRequestSupportListCtrl(selectedListItems, dataGen, ToastService, $redirect) {

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'RFXRequestSupportView'
        },
        {
            label: "startSupport",
            action: startSupport,
            type: 'dialogaction',
            condition: canStartSupport,
            process: 'RFXRequestSupportView'
        },
        {
            label: "finishSupport",
            action: finishSupport,
            type: 'dialogaction',
            condition: canFinishSupport,
            process: 'RFXRequestSupportView'
        }
    ];

    this.meta = {
        rowTemplate: 'modules/rfx/templates/rfxrequestsupportlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/support/request/list',
        id: "rfxlistrequestsupport",
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "rfx/requestsupport/" + selectedListItems.getFirstSelectedId();
    }

    function canFinishSupport() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canFinishSupport && firstSelectedItem.canFinishSupport.value;
    }

    function canStartSupport() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canStartSupport && firstSelectedItem.canStartSupport.value;
    }

    function finishSupport() {
        dataGen.postAsForm({}, {rfqhId: selectedListItems.getFirstSelectedId()}, "/rfx/support/request/finishsupport").then(function (data) {
            if(data.data && data.data.message) {
                ToastService.openStandardToast(data.data.message);
            }
            $redirect.reload();
        });
    }

    function startSupport () {
        dataGen.postAsForm({}, {rfqhId: selectedListItems.getFirstSelectedId()}, "/rfx/support/request/startsupport").then(function (data) {
            if(data.data && data.data.message) {
                ToastService.openStandardToast(data.data.message);
            }
            $redirect.redirectTo(null, getDetailLink());
        });
    }
}